module.exports = __webpack_public_path__ + "Roboto-Regular.30799efa5bf74129468a.eot";


//////////////////
// WEBPACK FOOTER
// ./~/angular-bootstrap-md/font/roboto/Roboto-Regular.eot
// module id = 233
// module chunks = 2